export const CUSTOM_LINK = 'custom';

export interface LinkPreset {
    key: string;
    label: string;
    link: string;
}

export function linkPresets(communityId: number): LinkPreset[] {
    return [
        { key: 'none', label: 'No link', link: '' },
        { key: 'company-tab', label: 'Company tab', link: '/whitelabel' },
        {
            key: 'community',
            label: 'Community page',
            link: `/clubs-list/c${communityId}`
        },
        {
            key: 'leaderboard',
            label: 'Community leaderboard',
            link: `/clubs-list/c${communityId}/leaderboard`
        },
        {
            key: 'connect-tracker',
            label: 'Connect a tracker',
            link: '/connect-tracker'
        },
        { key: 'shop', label: 'Rewards shop', link: '/shop' },
        { key: 'feed', label: 'Feed', link: '/feed' }
    ];
}

export function matchingPresetKey(
    presets: LinkPreset[],
    link?: string
): string {
    const trimmed = link?.trim() ?? '';
    return (
        presets.find((preset) => preset.link === trimmed)?.key ?? CUSTOM_LINK
    );
}
